<template>
  <Popup
      style="background: transparent"
      :value="show"
      :close-on-click-overlay="false">
    <div class="course-ad">
      <img style="width: 100%" :src="img" alt="">
      <div class="second-confirm-btn-group">
        <div class="confirm" @click="clickConfirm"></div>
      </div>
    </div>
    <div class="closebox">
      <img @click="closePopup" src="./adimg/close.png" alt="">
    </div>
  </Popup>
</template>

<script>
import {Popup} from 'vant';
import {dataBuryingPoint} from "@/utils/JSBridge.js";

export default {
  name: 'CourseAdPopup',
  props:{
    p:{
      type:String,
      default:"课程详情促销弹窗"
    },
    isCourse:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataBuryingPointTitle:"",
      courseId:"",
      show: false,
      title: "",
      desc: "",
      img: "",
      allImg: {
        cj: "https://p.hulian120.com/act/2022/cj_ks_jk.png",
        zg: "https://p.hulian120.com/act/2022/zg_ks_js.png",
      }
    }
  },
  methods: {
    openPopup(flag,courseId,name) {//1预发布,2正式初级,3正式主管
    this.courseId = courseId;
      this.title = "尊享用户";
      this.desc = "";
      this.dataBuryingPointTitle = name;
      if (flag == 1) {
        this.img = this.isCourse ? require('./adimg/cj.png') :this.allImg.cj;
      }
      if (flag == 2) {
        //this.dataBuryingPointTitle = "初级护师"
        this.img = this.isCourse ?require('./adimg/cj.png') :this.allImg.cj;
      }
      if (flag == 3) {
        //this.dataBuryingPointTitle = "主管护师"
        this.img = this.isCourse ?require('./adimg/zg.png') :this.allImg.zg;
      }
      this.show = true;
      dataBuryingPoint("KCXX-001", "KCXX-001-000", {
        desc:`${this.p}-${this.dataBuryingPointTitle}-弹窗曝光`,
        courseId:this.courseId,
      });
    },
    clickConfirm() {
      this.show = false
      dataBuryingPoint("KCXX-001", "KCXX-001-001", {
        desc:`${this.p}-${this.dataBuryingPointTitle}-点击购买按钮`,
        courseId:this.courseId,
      });
      setTimeout(()=>{
        this.$emit('ok');
      },460)
    },
    closePopup() {
      this.show = false
      dataBuryingPoint("KCXX-001", "KCXX-001-002", {
        desc:`${this.p}-${this.dataBuryingPointTitle}-点击关闭按钮`,
        courseId:this.courseId,
      });
      this.$emit('close')
    },
  },
  components: {Popup}
}
</script>

<style scoped lang="scss">
.closebox {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  img {
    display: inline-block;
    width: 30px;
  }
}
.course-ad {
  width: 295px;
  overflow: hidden;
  position: relative;
  .title {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    color: #323233;
  }

  .content {
    width: 100%;
    min-height: 50px;
    padding: 6px 20px;
    color: #7d7e80;
    text-align: center;
    font-size: 14px;
    img{
      width: 100%;
    }
    .desc{
      font-size: 14px;
      color: #7d7e80;
      text-align: center;

    }
  }

  .second-confirm-btn-group {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 62%;
      //background: #ff5555;
      color: #fff;
      border-radius: 25px;
    }
  }
}
</style>
